import React from 'react'
import BlogArticles from '../../Components/Blog/BlogArticles'
import HeroSection from '../../Components/Blog/HeroSection'


const Blog = () => {
  return (
    <div>
      <HeroSection />
      <BlogArticles />
    </div>
  )
}

export default Blog
